import React from 'react';
import styles from './RMDTransactions.module.scss';
import {
  getIsRMDBalanceAndAmountIsZero,
  getIsRMDPending,
} from '../../../redux/modules/RMD/RMDSetting.selectors';
import { getUserStateWithholdingRules } from '../../../redux/modules/stateWithholding/stateWithholding.selectors';
import {
  doesEverySystematicHaveAnAgreement,
  getIsRMDSpecialPayee,
  getIsRMDFundNonIRA,
  doesUserLEGoToTrust,
} from '../../../redux/modules/UserFunds/userFunds.selectors';
import { useSelector, useDispatch } from 'react-redux';
import MyToolTip from '../../../components/Shared/MyToolTip/MyToolTip';
import config from '../../../config/config';
import {
  openModal as openModalAction,
  DELETE_MODAL,
} from '../../../redux/modules/modals/modals.module';
import { appendBasePath } from '../../../utils/nav.utils';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import iconInfoIimg from '../../../assets/images/icon-questionmark-fill.svg';
import { currency } from '../../../utils/dashboard-utils';
import {
  isStateWithholding,
  printAgreementType,
  printFrequency,
  printFromData,
  printToData,
} from './RMDTransactionsUtil';

const RMDTransactions = ({
  autoSellSystematic,
  autoExchangeSystematic,
  rmdInfo,
  history,
}) => {
  const dispatch = useDispatch();
  const type = 'rmd-details';
  const sytematicsMatch = useSelector(doesEverySystematicHaveAnAgreement);
  const RMDBalanceAndAmountIsZero = useSelector(getIsRMDBalanceAndAmountIsZero);
  const isRMDSpecialPayee = useSelector(getIsRMDSpecialPayee);
  const isRMDFundNonIRA = useSelector(getIsRMDFundNonIRA);
  const userLETrust = useSelector(doesUserLEGoToTrust);
  const isRMDPending = useSelector(getIsRMDPending);
  const rmdIsHidden = rmdInfo?.some((fund) => fund.hidden);
  const showCallToEdit =
    userLETrust ||
    // RMDBalanceAndAmountIsZero ||
    isRMDSpecialPayee ||
    isRMDFundNonIRA ||
    !sytematicsMatch ||
    rmdIsHidden;
  const stateWithholdingData = useSelector(getUserStateWithholdingRules);
  const isPending = rmdInfo?.some((fund) => fund.pending === true);
  let allSystematic = [];
  if (autoExchangeSystematic) {
    allSystematic = [...allSystematic, ...autoExchangeSystematic];
  }
  if (autoSellSystematic) {
    allSystematic = [...allSystematic, ...autoSellSystematic];
  }
  let transactions = rmdInfo?.filter((fund) => {
    return !allSystematic.some(
      (en) =>
        en.encryptedUniqueKey === fund.encryptedUniqueKey &&
        en.electionAgreementUniqueId1 === fund.electionAgreementUniqueId1 &&
        en.electionAgreementUniqueId2 === fund.electionAgreementUniqueId2
    );
  });

  //and Exchange to new might return both funds back in the rmd but one fund is the target fund so it wont have an agreementID
  transactions = transactions.filter((fund) => {
    return (
      fund.deliveryType?.enumerationName !== 'ExchangeToNew' ||
      fund.targetAgreementKey.agreementID !== null
    );
  });
  return (
    <div style={{ overflow: 'auto' }}>
      <div className={styles['text-section']}>
        <>
          <div className={styles['title']}>
            <div className={styles['rmd-action-buttons-cons']}>
              <span>Auto-RMD Details</span>
              <div className={styles['rmd-action-buttons']}>
                {showCallToEdit && (
                  <MyToolTip
                    id={'Call-to-edit'}
                    descriptionBody={
                      <p className={styles['desc-text']}>
                        Please{' '}
                        <a
                          href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                          rel="noopener noreferrer"
                          target="_blank"
                          className={styles['contact-us-link']}
                        >
                          contact us
                        </a>{' '}
                        to make changes to your Required Minimum Distribution.
                      </p>
                    }
                    callerNode={
                      <span className={styles['pending-trade']}>
                        Call to Edit
                      </span>
                    }
                    maxNoteWidth="300px"
                  />
                )}
                {isPending && !showCallToEdit && (
                  <MyToolTip
                    id={`pending--rmd-transactions-1`}
                    descriptionBody={
                      <p className={styles['desc-text']}>
                        Update may take up to five business days to process.
                        Please{' '}
                        <a
                          href={`${config.url}/personal-investing/help/contact/index.html`}
                          rel="noopener noreferrer"
                          target="_blank"
                          className={styles['contact-us-link']}
                        >
                          contact us
                        </a>{' '}
                        to make changes.
                      </p>
                    }
                    callerNode={
                      <span className={styles['pending-trade']}>Pending</span>
                    }
                    maxNoteWidth="250px"
                  />
                )}

                {!isPending && !showCallToEdit && (
                  <div className={`${styles['action-button-con']}`}>
                    <a
                      id="edit-auto-rmd"
                      onClick={(e) => {
                        //dispatch(moduleActions.applicationDataLoading());
                        e.preventDefault();
                        window.scrollTo({ top: 0 });
                        history.push(appendBasePath('/edit/destination'));
                      }}
                      className={styles['action-button']}
                    >
                      Edit
                    </a>
                    <div
                      className={styles['automatic-action-options-spacer']}
                    />
                    <a
                      className={styles['action-link']}
                      onClick={(e) => dispatch(openModalAction(DELETE_MODAL))}
                    >
                      {' '}
                      Delete
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
          <p className={styles['text-block']}>
            Amount will be recalculated every year per IRS guidelines and does
            not account for transactions completed after the recalculation
            period (approximately mid-January).
          </p>
        </>
        <div className={styles['table-container']}>
          <table className={styles['table']}>
            <thead>
              <tr className={styles['table-title']}>
                <th className={styles['header']}>From</th>
                <th className={styles['header']}>To</th>
                <th className={styles['header']}>Frequency</th>
                <th className={styles['header']}>Withholding</th>
                {!isRMDPending.pending && (
                  <th className={styles['header-num']}>Amount</th>
                )}
              </tr>
            </thead>
            {transactions?.map((fund, i) => (
              <tr className={styles['table-elements']}>
                <td className={styles['body']}>
                  <div className={styles['autosell-from']}>
                    <strong className={`${styles['fund-type']} blocked_data`}>
                      {printFromData(
                        fund?.sourceAgreementKey.agreementID,
                        'displayClassification'
                      )?.replace('_', '-')}{' '}
                      /{' '}
                      {printAgreementType(
                        printFromData(
                          fund.sourceAgreementKey.agreementID,
                          'agreementType'
                        )
                      )}
                    </strong>
                    <br />
                    <span className={`${styles['fund-name']} blocked_data`}>
                      {printFromData(
                        fund.sourceAgreementKey.agreementID,
                        'fundName'
                      )}
                    </span>
                    <span className={styles['fund-ticker']}>
                      {printFromData(
                        fund.sourceAgreementKey.agreementID,
                        'ticker'
                      )}
                    </span>
                    <span
                      className={`${styles['fund-ticker']} ${styles['rmdAgreement-account-number']}`}
                    >
                      {fund?.accountNumber}-{fund.checkSum}
                    </span>
                  </div>
                </td>
                <td className={styles['body']}>
                  <div className={`${styles['autosell-from']} blocked_data`}>
                    {printToData(fund, fund.sourceAgreementKey.agreementID)}
                  </div>
                </td>
                <td className={styles['account-name']}>
                  <span>{printFrequency(fund)}</span>
                  <MyToolTip
                    title='frequency tool tip'
                    aria-label='frequency-tool-tip'
                    id={`rmd-frequency-${type}-` + fund.encryptedUniqueKey}
                    descriptionBody={
                      <p className={styles['desc-text']}>
                        Federal and applicable state income tax withholding will
                        apply. RMD will be recalculated every year.
                      </p>
                    }
                    callerNode={
                      <img
                        className={styles['tooltip-icon-frequency']}
                        src={iconInfoIimg}
                        alt="Frequency Tooltip Icon"
                      />
                    }
                    maxNoteWidth="300px"
                  />
                </td>
                <td className={styles['account-name']}>
                  <>
                    {fund.IRAWithholding > 0 && 'Federal: '}
                    {fund.IRAWithholding > 0 ? fund.IRAWithholding : 'Declined'}
                    {fund.IRAWithholding > 0 ? '%' : ''}
                    {isStateWithholding(fund) && (
                      <>
                        ; State:{' '}
                        {stateWithholdingData?.address === 'MN' &&
                          'Not available'}
                        {stateWithholdingData?.address !== 'MN' &&
                          stateWithholdingData.percent + '%'}
                      </>
                    )}
                  </>
                  <MyToolTip
                    id={`rmd-withdraw-${type}-` + fund.encryptedUniqueKey}
                    descriptionBody={
                      <p className={styles['desc-text']}>
                        The state witholding shown is the default amount per
                        your applicable state's rules. This may not reflect
                        individualized preferences (i.e. requested increased
                        amount or a W-4R exemption)
                      </p>
                    }
                    callerNode={
                      <img
                        className={styles['tooltip-icon']}
                        src={iconInfoIimg}
                        alt="Frequency Tooltip Icon"
                      />
                    }
                    maxNoteWidth="300px"
                  />
                </td>
                {transactions?.length > 0 &&
                  !transactions[0].pendingTrade &&
                  !isRMDPending.pending && (
                    <td className={styles['num']}>{currency(fund.amount)}</td>
                  )}
              </tr>
            ))}
          </table>
        </div>
      </div>
    </div>
  );
};

export default compose(withRouter)(RMDTransactions);
